import { GAME_TYPES } from 'components/config/games';

import { ReactComponent as BallIcon } from 'images/Icons/Ball.svg';
import { ReactComponent as SlotsIcon } from 'images/Icons/Slots.svg';
import { ReactComponent as TableIcon } from 'images/Icons/Table.svg';

export const LIMITS = {
  byCategory: 20,
  byRetention: 10,
};

export const TOP_GAME_PERIODS = {
  lastMonth: 'last_month',
  last3Months: 'last_3_months',
  last6Months: 'last_6_months',
  lastYear: 'last_year',
};

export const TOP_GAME_COLORS = {
  byGeo: ['#FF43210D', '#FDB10E0D', '#8ACB000D', '#0099FA0D'],
  byCategory: ['#FDB10E', '#A33EE8', '#0069FF'],
  byRetention: ['#A33EE8', '#0099FA', '#8ACB00'],
};

export const OPTIONS = {
  gameTypes: [
    {
      label: 'Top video slots',
      value: GAME_TYPES.videoSlot,
      Icon: SlotsIcon,
    },
    {
      label: 'Top instant games',
      value: GAME_TYPES.instantGame,
      Icon: BallIcon,
      iconType: 'stroke',
    },
    {
      label: 'Top table games',
      value: GAME_TYPES.tableGame,
      Icon: TableIcon,
    },
  ],
  periodsByCategory: [
    {
      label: 'Last Month',
      value: TOP_GAME_PERIODS.lastMonth,
    },
    {
      label: 'Last 3 Months',
      value: TOP_GAME_PERIODS.last3Months,
    },
    {
      label: 'Last 6 Months',
      value: TOP_GAME_PERIODS.last6Months,
    },
    {
      label: 'Last Year',
      value: TOP_GAME_PERIODS.lastYear,
    },
  ],
};

export const DISCLAIMER_ITEMS = [
  {
    title: 'Third-Party Distribution.',
    description:
      'Some games listed are distributed by third-party partners, not directly by Evoplay. We do not guarantee the accuracy, availability, or performance of these third-party games.',
  },
  {
    title: 'Information Accuracy.',
    description:
      'We strive for accuracy in our game usage statistics and other data, but this information may change frequently. We do not warrant its completeness, accuracy, or reliability.',
  },
  {
    title: 'Non-endorsement.',
    description:
      'The inclusion of any game does not constitute an endorsement or recommendation by Evoplay.',
  },
  {
    title: 'Limitation of Liability.',
    description:
      'Evoplay is not liable for any damages arising from the use of this website or the information presented, including inaccuracies or third-party issues.',
  },
  {
    title: 'Changes and Updates.',
    description:
      'We may modify this disclaimer and any information on our website at any time without notice.',
  },
];
